import { createContext, useContext } from 'react';

/**
 * Largeur du bloc courant dans l'aperçu impression : 'full' (pleine largeur)
 * ou 'half' (demi-colonne de masonry). Fourni par SectionRenderer.renderBlock
 * (EvalPrintPage) dans les DEUX phases (mesure et affichage → même DOM),
 * consommé par les SVG à géométrie fixe (droite graduée, figures compas) qui
 * doivent garder des textes lisibles quand leur conteneur est deux fois plus
 * étroit : STANDARD PAPIER, pas de zoom possible sur une feuille.
 *
 * Hors bloc (corrigé, sondes) : 'full'.
 */
export const LargeurBloc = createContext('full');

export const useLargeurBloc = () => useContext(LargeurBloc);
